module.exports = "<div class=\"login_outer\">\r\n  <div class=\"logo_dv\">\r\n    <img src=\"assets/images/Assisted Living Financial Suite.jpg\" alt=\"RAL FINANCIAL SUITE\" width=\"196\" height=\"123\">\r\n  </div>\r\n  <div class=\"login-box\">\r\n    <div class=\"login-box-body\">\r\n      <p>Validating user authentication token...</p>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/auth.component.html
// module id = ./src/app/auth/auth.component.html
// module chunks = main